const initTabImageText = (root) => {
  const tabs = Array.from(root.querySelectorAll('[data-tit-tab]'));
  const panels = Array.from(root.querySelectorAll('[data-tit-panel]'));

  if (!tabs.length || !panels.length) return;

  const setActive = (index) => {
    tabs.forEach((tab) => {
      const isActive = tab.dataset.titIndex === String(index);
      tab.classList.toggle('active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    panels.forEach((panel) => {
      panel.classList.toggle('active', panel.dataset.titIndex === String(index));
    });
  };

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      setActive(tab.dataset.titIndex);
    });
  });
};

document.querySelectorAll('.tit').forEach(initTabImageText);

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('.tit').forEach(initTabImageText);
});
